module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185909.31704590.jpg";